import { CSSObject } from '@chakra-ui/react';
import { BreadcrumbSchema } from './Breadcrumb.styles';

export const breadcrumbStyles: BreadcrumbSchema = {
  breadcrumbWrapper: {
    borderRadius: '4px',
    pl: ['10px', null, null, '16px'],
    pr: '10px',
    h: '38px',
    display: 'flex',
    alignItems: 'center',
    sx: { '&::-webkit-scrollbar': { display: 'none' } },
  },
  breadcrumbLinkItem: {
    fontSize: '10px',
    fontWeight: '800',
    color: 'whiteAlpha.500',
    textDecoration: 'none',
    fontFamily: 'accent',

    _hover: {
      textDecoration: 'underline',
    },

    sx: {
      '&:not([href])': {
        color: 'beta.500',
        textDecoration: 'none',
      },
    },
  },
};
export const ChevronRightIcon: CSSObject = {
  color: 'whiteAlpha.500',
};
